import { useState } from "react";

import { useGlobalAudioPlayer } from "@/contexts/GlobalAudioPlayerContext";
import { cx } from "@/utils";
import PlayButton from "@components/PlayButton";
import Quote from "@components/Quote";
import Typography from "@components/Typography";

import { useEpisode } from "../../../context";
import { useLocalAudio } from "../../../LocalAudioContext";
import ExternalLink from "../../Body/partials/ExternalLink";
import ExpandMentions from "../partials/ExpandMentions";

import styles from "./AudioBodyMobile.module.css";

const AudioBodyMobile = (props: { defaultOpen: boolean }) => {
  const { audioMentions } = useEpisode();
  const { register } = useGlobalAudioPlayer();
  const {
    audio,
    playing,
    errored,
    loading,
    currentTime = 0,
  } = useLocalAudio({
    playing: true,
    loading: true,
    errored: true,
    currentTime: true,
  });

  const [expanded, setExpanded] = useState(props.defaultOpen);

  return (
    <div>
      {audioMentions.length > 0 && (
        <div className={styles.actions} onClick={() => setExpanded((v) => !v)}>
          <PlayButton
            className={styles.play}
            error={errored}
            loading={loading}
            playing={playing}
            onClick={(e) => {
              // Stop the event on the parent from triggering.
              // This will always just open.
              e.stopPropagation();
              if (playing) {
                audio?.pause();
              } else {
                if (audioMentions[0]) {
                  audio?.play(audioMentions[0].context_start_timing);
                } else {
                  audio?.play();
                }
              }
              setExpanded(true);
              if (audio) {
                register(audio);
              }
            }}
          />
          <ExpandMentions open={expanded} />
        </div>
      )}
      {expanded &&
        audioMentions.map((m) => (
          <Typography
            key={m.public_id}
            className={cx(
              styles.mention,
              {
                [styles.current]:
                  m.context_start_timing >= currentTime &&
                  m.context_end_timing <= currentTime,
                [styles.dim]:
                  playing &&
                  !(
                    m.context_start_timing >= currentTime &&
                    m.context_end_timing <= currentTime
                  ),
              },
              "highlight-match"
            )}
            onClick={() => {
              audio?.play(m.context_start_timing);
            }}
            variant="monospace"
          >
            <Quote>
              <span dangerouslySetInnerHTML={{ __html: m.trimmed_content }} />
            </Quote>
          </Typography>
        ))}
      {expanded && <ExternalLink />}
    </div>
  );
};

export default AudioBodyMobile;
